import jQuery from 'jquery';
import EventService from '../../common/event/EventService';
import translate from '../../common/localization/translate';
import PortletEvent from '../../vcom/events/PortletEvent';

/*
 * jQuery UI Portlet 1.8.0
 *
 * Copyright (c) 2010 meteocontrol GmbH
 *
 * Depends:
 *     ui.core.js
 *     ui.draggable.js
 *     ui.resizable.js
 */
export default (function ($) {
  var uiPortletClasses = 'ui-portlet ';

  $.widget('ui.portlet', {
    options: {
      autoOpen: true,
      closeOnEscape: false,
      closeText: 'close',
      configurable: true,
      configText: 'configure',
      draggable: true,
      closeable: false,
      height: 'auto',
      hide: null,
      maximizeText: 'maximize',
      maxHeight: false,
      maxWidth: false,
      minHeight: 150,
      minWidth: 150,
      portletClass: '',
      position: 'center',
      resizable: true,
      show: null,
      stack: true,
      title: '',
      titlebar: true,
      zIndex: 1000,
    },

    _create() {
      this.originalTitle = this.element.attr('title');

      var self = this;
      var options = self.options;

      var title = options.title || self.originalTitle || '&#160;';
      var titleId = $.ui.portlet.getTitleId(self.element);
      const badges = $(this.element).data('badges');
      badges.forEach((badge) => {
        title += `<span class="badge text-capitalize ml-2">${translate(badge)}</span>`;
      });

      self.originalPos = [0, 0];
      self.originalSize = [0, 0];

      var uiPortlet = (self.uiPortlet = $('<div/>'))
        .appendTo(self.element.parent())
        .addClass(uiPortletClasses + options.portletClass)
        .css({
          position: 'absolute',
          overflow: 'hidden',
          visibility: 'hidden',
          zIndex: options.zIndex,
        })
        // setting tabIndex makes the div focusable
        // setting outline to 0 prevents a border on focus in Mozilla
        .attr('tabIndex', -1)
        .css('outline', 0)
        .on('keydown', (event) => {
          if (options.closeOnEscape && event.keyCode && event.keyCode === $.ui.keyCode.ESCAPE) {
            self.close(event);
          }
        })
        .attr({
          role: 'presentation',
          'aria-labelledby': titleId,
        })
        .on('mousedown', (event) => {
          self.moveToTop(false, event);
        });

      var portletWrapper = $('<div/>').css({
        background: 'none',
        position: 'relative',
        overflow: 'hidden',
        height: '100%',
        padding: '2px',
        'box-sizing': 'border-box',
      });

      var contentWrapper = $('<div/>').addClass('ui-widget-content ui-corner-all ui-widget ui-dialog');
      contentWrapper.css({
        width: '100%',
        height: '100%',
        position: 'relative',
        padding: '0px',
      });

      var uiPortletContent = self.element
        .show()
        .removeAttr('title')
        .addClass('ui-dialog-content ui-widget-content')
        .appendTo(contentWrapper);

      let titlebarButtons;
      let uiPortletTitlebar;
      if (options.titlebar) {
        var titlebarWrapper = $('<div/>');
        titlebarWrapper.css({
          position: 'relative',
        });

        uiPortletTitlebar = (self.uiPortletTitlebar = $('<div></div>'))
          .addClass('ui-dialog-titlebar ui-widget-header ui-corner-all ui-helper-clearfix')
          .appendTo(titlebarWrapper);

        titlebarButtons = $('<div/>').addClass('ui-dialog-titlebar-buttons');
        titlebarButtons.appendTo(uiPortletTitlebar);

        titlebarWrapper.prependTo(contentWrapper);
      }

      contentWrapper.appendTo(portletWrapper);
      portletWrapper.appendTo(uiPortlet);

      self.uiPortletConfig = $('.ui-portlet-config', uiPortletContent);

      self.portletElement = uiPortletContent.children().first();

      if (options.closeable && options.titlebar) {
        var uiPortletTitlebarClose = $('<a href="#"/>')
          .addClass('ui-dialog-titlebar-button ui-dialog-titlebar-close')
          .attr('role', 'button')
          .attr('title', translate('javascript.TX_CLOSE'))
          .on('click', (event) => {
            self.close(event);
            return false;
          })
          .prependTo(titlebarButtons);

        (self.uiPortletTitlebarCloseIcon = $('<span/>'))
          .addClass('icon-header icon-cross')
          .attr('name', 'portlet-close-button')
          .appendTo(uiPortletTitlebarClose);
      }

      if (options.titlebar) {
        var uiPortletTitlebarToggleSize = $('<a href="#"/>')
          .addClass('ui-dialog-titlebar-button ui-dialog-titlebar-maximize')
          .attr('role', 'button')
          .attr('title', self.getToggleSizeLabel())
          .on('click', (event) => {
            self.toggleSize(event);
            self.setToggleSizeLabel(uiPortletTitlebarToggleSize);
            return false;
          })
          .prependTo(titlebarButtons);

        (self.uiPortletTitlebarToggleSizeText = $('<span/>'))
          .addClass('icon-header icon-popout2')
          .attr('name', 'portlet-toggle-fullscreen-button')
          .appendTo(uiPortletTitlebarToggleSize);

        $('<span/>')
          .addClass('ui-portlet-title')
          .attr('id', titleId)
          .html(title)
          .prependTo(uiPortletTitlebar);
      }

      if (options.configurable && options.titlebar) {
        var uiPortletTitlebarToggleConfig = $('<a href="#"/>')
          .addClass('ui-dialog-titlebar-button ui-dialog-titlebar-configure ')
          .attr('role', 'button')
          .attr('title', translate('default.SETTINGS'))
          .on('click', (event) => {
            if (!self.uiPortletConfig.hasClass('disable-slide')) {
              self.toggleConfig(event);
            }
            EventService.dispatch(PortletEvent.CONFIG_CLICKED, { target: self.element[0] });
            return false;
          })
          .prependTo(titlebarButtons);

        (self.uiPortletTitlebarToggleConfigText = $('<span/>'))
          .addClass('icon-header icon-wrench')
          .attr('name', 'portlet-settings-button')
          .appendTo(uiPortletTitlebarToggleConfig);
      }

      if (options.draggable && $.fn.draggable) {
        self._makeDraggable();
      }
      if (options.resizable && $.fn.resizable) {
        self._makeResizable();
      }

      self._isOpen = false;
      self._isReady = false;

      if ($.fn.bgiframe) {
        uiPortlet.bgiframe();
      }
    },

    _init() {
      if (this.options.autoOpen) {
        this.open();
      }
    },

    destroy() {
      var self = this;
      self.uiPortlet.hide();
      self.element
        .off('.portlet')
        .removeData('portlet')
        .removeClass('ui-dialog-content ui-widget-content')
        .hide()
        .appendTo('body');
      self.uiPortlet.remove();

      if (self.originalTitle) {
        self.element.attr('title', self.originalTitle);
      }

      return self;
    },

    widget() {
      return this.uiPortlet;
    },

    close(event, withForce = false) {
      var self = this;

      if (!withForce && self._trigger('beforeClose', event) === false) {
        return;
      }

      self.uiPortlet.off('keypress.ui-portlet');

      self._isOpen = false;

      if (self.options.hide) {
        self.uiPortlet.hide(self.options.hide, () => {
          self._trigger('close', event);
        });
      } else {
        EventService.dispatch(PortletEvent.DESTROYED, { target: self.element[0] });
        self.element
          .trigger(PortletEvent.DESTROYED)
          .remove();
        self._trigger('close', event);
      }

      return self;
    },

    getToggleSizeLabel() {
      const self = this;
      const label = self.isMaximized() ? 'portlet.MINIMIZE' : 'portlet.MAXIMIZE';
      return translate(label);
    },

    setToggleSizeLabel(toggleButton) {
      const self = this;
      toggleButton.attr('title', self.getToggleSizeLabel());
    },

    toggleSize(event, ...args) {
      var self = this;
      if (self._isMaximized) {
        self._position([self.originalPos.left, self.originalPos.top]);
        self.uiPortlet.width(self.originalSize.width);
        self.uiPortlet.height(self.originalSize.height);
        self.element.innerHeight(self.uiPortlet.children().first().height() - this._titlebarHeight());
        if (self.options.resizeStop) {
          self.options.resizeStop.apply([self.element[0], ...args]);
        }
        self._isMaximized = false;
        EventService.dispatch(PortletEvent.MINIMIZED, { target: self.element[0] });
        return;
      }
      // save current position
      self.originalPos = self.uiPortlet.position();
      self.originalSize = { width: self.uiPortlet.width(), height: self.uiPortlet.height() };
      // set new position
      self._isMaximized = true;
      self._position({ left: 0, top: 0 });
      self.uiPortlet.width(self.options.maxWidth);
      self.uiPortlet.height(self.options.maxHeight);
      self.element.innerHeight(self.uiPortlet.children().first().height() - this._titlebarHeight());
      self.moveToTop();
      if (self.options.resizeStop) {
        self.options.resizeStop.apply([self.element[0], ...args]);
      }
      EventService.dispatch(PortletEvent.MAXIMIZED, { target: self.element[0] });
    },

    toggleConfig() {
      if (this._isConfigView) {
        this._isConfigView = false;
        this.uiPortletConfig.slideUp();
        return;
      }
      this.uiPortletConfig.slideDown();
      this._isConfigView = true;
    },

    resize() {
      this._size();
    },

    isReady() {
      return this._isReady;
    },

    isOpen() {
      return this._isOpen;
    },

    moveToTop(force, event) {
      var self = this;
      var options = self.options;
      var saveScroll;

      if (options.zIndex > $.ui.portlet.maxZ) {
        $.ui.portlet.maxZ = options.zIndex;
      }

      // Save and then restore scroll since Opera 9.5+ resets when parent z-Index is changed.
      //  http://ui.jquery.com/bugs/ticket/3193
      saveScroll = { scrollTop: self.element.attr('scrollTop'), scrollLeft: self.element.attr('scrollLeft') };
      $.ui.portlet.maxZ += 1;
      self.uiPortlet.css('z-index', $.ui.portlet.maxZ);
      self.element.attr(saveScroll);
      self._trigger('focus', event);

      return self;
    },

    open() {
      if (this._isOpen) {
        return;
      }

      var self = this;
      var options = self.options;
      var uiPortlet = self.uiPortlet;

      if (uiPortlet.next().length) {
        uiPortlet.appendTo('body');
      }
      self._size();
      self._position(options.position);
      uiPortlet.css('visibility', 'visible');
      self._trigger('ready');
      self._isReady = true;
      self.moveToTop(true);
      self._trigger('open');
      self._isOpen = true;

      return self;
    },

    indicateUpdate() {
      if (typeof this.uiPortletTitlebarCloseIcon !== 'undefined') {
        this.uiPortletTitlebarCloseIcon.addClass('icomoon icomoon-spin icon-spinner2').removeClass('icon-cross');
      }
    },

    updateFinished() {
      if (typeof this.uiPortletTitlebarCloseIcon !== 'undefined') {
        this.uiPortletTitlebarCloseIcon.removeClass('icomoon icomoon-spin icon-spinner2').addClass('icon-cross');
      }
    },

    isMaximized() {
      return this._isMaximized;
    },

    _makeDraggable() {
      var self = this;
      var options = self.options;
      var doc = $(document);
      var heightBeforeDrag;

      function filteredUi(ui) {
        return {
          position: ui.position,
          offset: ui.offset,
        };
      }

      self.uiPortlet.draggable({
        cancel: '.ui-dialog-content, .ui-dialog-titlebar-close',
        handle: '.ui-dialog-titlebar',
        containment: '#content div.portal',
        grid: options.grid,
        opacity: 0.50,
        start(event, ui) {
          heightBeforeDrag = options.height === 'auto' ? 'auto' : $(this).height();
          $(this).height($(this).height()).addClass('ui-portlet-dragging');
          self._trigger('dragStart', event, filteredUi(ui));
        },
        drag(event, ui) {
          self._trigger('drag', event, filteredUi(ui));
        },
        stop(event, ui) {
          options.position = [
            ui.position.left - doc.scrollLeft(),
            ui.position.top - doc.scrollTop(),
          ];
          $(this).removeClass('ui-portlet-dragging').height(heightBeforeDrag);
          self._trigger('dragStop', event, filteredUi(ui));
        },
      });
    },

    _makeResizable(handles) {
      handles = (handles === undefined ? this.options.resizable : handles);
      var self = this;
      var options = self.options;
      // .ui-resizable has position: relative defined in the stylesheet
      // but dialogs have to use absolute or fixed positioning
      var position = self.uiPortlet.css('position');
      var resizeHandles = (typeof handles === 'string' ?
        handles :
        'n,e,s,w,se,sw,ne,nw'
      );

      function filteredUi(ui) {
        return {
          originalPosition: ui.originalPosition,
          originalSize: ui.originalSize,
          position: ui.position,
          size: ui.size,
        };
      }

      self.uiPortlet.resizable({
        cancel: '.ui-dialog-content',
        containment: '#content div.portal',
        maxWidth: options.maxWidth,
        maxHeight: options.maxHeight,
        minWidth: self._minWidth(),
        minHeight: self._minHeight(),
        grid: options.grid,
        handles: resizeHandles,
        start(event, ui) {
          $(this).addClass('ui-portlet-resizing');
          self._trigger('resizeStart', event, filteredUi(ui));
        },
        resize(event, ui) {
          options.height = $(this).height();
          options.width = $(this).width();
          self.element.innerHeight(self.uiPortlet.children().first().height() - self._titlebarHeight());
          self._trigger('resize', event, filteredUi(ui));
        },
        stop(event, ui) {
          $(this).removeClass('ui-portlet-resizing');
          self._trigger('resizeStop', event, filteredUi(ui));
        },
      })
        .css('position', position)
        .find('.ui-resizable-se').removeClass('ui-icon ui-icon-grip-diagonal-se');
    },

    _minWidth() {
      return this.portletElement.data('min-width') ?? this.options.minWidth;
    },

    _minHeight() {
      var minHeight = this.portletElement.data('min-height');
      if (minHeight) {
        return minHeight;
      }
      var options = this.options;

      if (options.height === 'auto') {
        return options.minHeight;
      }
      return Math.min(options.minHeight, options.height);
    },

    _position(position) {
      var myAt = [];
      var offset = [0, 0];
      var isVisible;

      position = position || $.ui.portlet.prototype.options.position;

      if (typeof position === 'string' || (typeof position === 'object' && '0' in position)) {
        myAt = position.split ? position.split(' ') : [position[0], position[1]];
        if (myAt.length === 1) {
          [myAt[1]] = myAt;
        }

        $.each(['left', 'top'], (i, offsetPosition) => {
          if (+myAt[i] === myAt[i]) {
            offset[i] = myAt[i];
            myAt[i] = offsetPosition;
          }
        });
      } else if (typeof position === 'object') {
        if ('left' in position) {
          myAt[0] = 'left';
          offset[0] = position.left;
        } else if ('right' in position) {
          myAt[0] = 'right';
          offset[0] = -position.right;
        }

        if ('top' in position) {
          myAt[1] = 'top';
          offset[1] = position.top;
        } else if ('bottom' in position) {
          myAt[1] = 'bottom';
          offset[1] = -position.bottom;
        }
      }

      // need to show the dialog to get the actual offset in the position plugin
      isVisible = this.uiPortlet.is(':visible');
      if (!isVisible) {
        this.uiPortlet.show();
      }
      this.uiPortlet
        .position({
          my: myAt.join(' '),
          at: `${myAt[0]}+${offset[0]} ${myAt[1]}+${offset[1]}`,
          of: '#content div.portal',
          collision: 'none',
          // ensure that the titlebar is never outside the document
          using(pos) {
            var topOffset = $(this).css(pos).offset().top;
            if (topOffset < 0) {
              $(this).css('top', pos.top - topOffset);
            }
          },
        });
      if (!isVisible) {
        this.uiPortlet.hide();
      }
    },

    _setOption(key, value, ...args) {
      var self = this;
      var uiPortlet = self.uiPortlet;
      var isResizable = uiPortlet.is(':ui-resizable');
      var isDraggable = uiPortlet.is(':ui-draggable');
      var resize = false;

      switch (key) {
        case 'closeText':
          // convert whatever was passed in to a string, for text() to not throw up
          self.uiPortletTitlebarCloseIcon.text(String(value));
          break;
        case 'configText':
          // convert whatever was passed in to a string, for text() to not throw up
          self.uiPortletTitlebarConfigText.text(String(value));
          break;
        case 'toggleSizeText':
          // convert whatever was passed in to a string, for text() to not throw up
          self.uiPortletTitlebarToggleSizeText.text(String(value));
          break;
        case 'portletClass':
          uiPortlet
            .removeClass(self.options.portletClass)
            .addClass(uiPortletClasses + value);
          break;
        case 'disabled':
          if (value) {
            uiPortlet.addClass('ui-portlet-disabled');
          } else {
            uiPortlet.removeClass('ui-portlet-disabled');
          }
          break;
        case 'draggable':
          if (value) {
            self._makeDraggable();
          } else {
            uiPortlet.draggable('destroy');
          }
          break;
        case 'grid':
          if (value) {
            if (isDraggable) {
              uiPortlet.draggable('option', 'grid', value);
            }
            if (isResizable) {
              uiPortlet.resizable('option', 'grid', value);
            }
          }
          break;
        case 'height':
          resize = true;
          break;
        case 'maxHeight':
          if (isResizable) {
            uiPortlet.resizable('option', 'maxHeight', value);
          }
          resize = true;
          break;
        case 'maxWidth':
          if (isResizable) {
            uiPortlet.resizable('option', 'maxWidth', value);
          }
          resize = true;
          break;
        case 'minHeight':
          if (isResizable) {
            uiPortlet.resizable('option', 'minHeight', value);
          }
          resize = true;
          break;
        case 'minWidth':
          if (isResizable) {
            uiPortlet.resizable('option', 'minWidth', value);
          }
          resize = true;
          break;
        case 'position':
          self._position(value);
          break;
        case 'resizable':
          // currently resizable, becoming non-resizable
          if (isResizable && !value) {
            uiPortlet.resizable('destroy');
          }

          // currently resizable, changing handles
          if (isResizable && typeof value === 'string') {
            uiPortlet.resizable('option', 'handles', value);
          }

          // currently non-resizable, becoming resizable
          if (!isResizable && value !== false) {
            self._makeResizable(value);
          }
          break;
        case 'title':
          // convert whatever was passed in o a string, for html() to not throw up
          if (this.options.titlebar) {
            $('.ui-portlet-title', self.uiPortletTitlebar).html(String(value || '&#160;'));
          }
          break;
        case 'width':
          resize = true;
          break;
        case 'indicateUpdate':
          self.indicateUpdate();
          break;
        case 'updateFinished':
          self.updateFinished();
          break;
        case 'toggleConfig':
          self.toggleConfig();
          break;
        default:
          break;
      }

      $.Widget.prototype._setOption.apply(self, [key, value, ...args]);
      if (resize) {
        self._size();
      }
    },

    _size() {
      /* If the user has resized the dialog, the .ui-dialog and .ui-dialog-content
             * divs will both have width and height set, so we need to reset them
             */
      var options = this.options;

      // reset content sizing
      this.element.css('width', 'auto');

      // reset wrapper sizing
      // determine the height of all the non-content elements
      this.uiPortlet.css({
        height: 'auto',
        width: options.width,
      });

      this.uiPortlet.height(options.height);

      this.element
        .css('minHeight', 0)
        .innerHeight(this.uiPortlet.children().first().height() - this._titlebarHeight());

      if (this.uiPortlet.is(':data(uiResizable)')) {
        this.uiPortlet.resizable('option', 'minHeight', this._minHeight());
      }
    },

    _titlebarHeight() {
      return this.element.siblings().height();
    },
  });

  $.extend($.ui.portlet, {
    version: '1.8',

    uuid: 0,
    maxZ: 0,

    getTitleId($el) {
      var id = $el.attr('id');
      if (!id) {
        this.uuid += 1;
        id = this.uuid;
      }
      return `ui-portlet-title-${id}`;
    },
  });
}(jQuery));
